import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "@/i18n";
import { L } from "@/components/L";

const KEY = "made-cookie-consent";

const apply = (value) => {
  const ph = window.posthog;
  if (!ph) return;
  if (value === "accepted") ph.opt_in_capturing?.();
  else ph.opt_out_capturing?.();
};

export default function CookieBanner() {
  const { t } = useLang();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (saved) apply(saved);
    else setOpen(true);
    const reopen = () => setOpen(true);
    window.addEventListener("made:cookie-open", reopen);
    return () => window.removeEventListener("made:cookie-open", reopen);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    apply(value);
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          role="dialog"
          aria-live="polite"
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 40, opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[70] bg-white rounded-[1.5rem_1.5rem_1.5rem_0.25rem] p-5 shadow-[0_24px_60px_-20px_rgba(19,61,42,.35)] border border-[var(--line)]"
          data-testid="cookie-banner"
        >
          <p className="text-sm text-[var(--ink-soft)] leading-relaxed">{t.cookie.text} <L to="cookies" className="underline text-[var(--green-deep)]">{t.cookie.more}</L></p>
          <div className="mt-4 flex gap-2">
            <button onClick={() => choose("accepted")} className="btn btn-primary !py-2.5 !px-5 text-sm" data-testid="cookie-accept-btn">{t.cookie.accept}</button>
            <button onClick={() => choose("rejected")} className="btn btn-ghost !py-2.5 !px-5 text-sm" data-testid="cookie-reject-btn">{t.cookie.reject}</button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
